module.exports = __webpack_public_path__ + "img/footer-qrcode.999900fd.png";